import Button from "@mui/material/Button";
import FullScreenModal from "components/common/FullScreenModal";
import React, { useRef } from "react";
import RelatedForm from "./RelatedForm";

const RelatedModal = (props) => {
    const {
        editing,
        open,
        addStatus,
        editStatus,
        initValues,
        onAdd,
        onEdit,
        toggleRelatedFilmsForm,
        advId,
        changeAssociations,
        associations,
    } = props;

    const formRef = useRef();

    const handleClose = () => {
        toggleRelatedFilmsForm();
    };

    const submitForm = () => {
        formRef.current.submitForm();
    };

    return (
        <FullScreenModal
            btns={
                <Button variant={"contained"} size={"small"} color={"secondary"} onClick={submitForm}>
                    Save
                </Button>
            }
            title={`${!editing ? "ADD" : "EDIT"} RELATED FILM`}
            open={open}
            handleClose={handleClose}
        >
            <RelatedForm
                ref={formRef}
                addStatus={addStatus}
                editStatus={editStatus}
                editing={editing}
                onAdd={onAdd}
                onEdit={onEdit}
                initValues={initValues}
                advId={advId}
                changeAssociations={changeAssociations}
                associations={associations}
            />
        </FullScreenModal>
    );
};

export default RelatedModal;
